import reducer from './reducers';

export { default as fileSelectors } from './selectors';
export { default as fileOperations } from './operations';
export { default as fileTypes } from './types';

export default reducer;
